/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import TouristsInputValue from '../TouristsInputValue/TouristsInputValue';
import NightsInputValue from '../NightsInputValue/NightsInputValue';
import DayPickerInputValue from '../DayPickerInputValue/DayPickerInputValue';
import DestinationInputValue from '../DestinationInputValue/DestinationInputValue';
import HotelInputValue from '../HotelInputValue/HotelInputValue';
import FromInputValue from '../FromInputValue/FromInputValue';

import {
  FROM_ID,
  TO_ID,
  HOTEL_ID,
  WHEN_ID,
  NIGHTS_ID,
  TOURISTS_ID,
} from '../../../../Utils/Constants/HomePageConstants';

class InputValue extends React.Component {
  selectInputValue = (id) => {
    const { value } = this.props;

    switch (id) {
      case FROM_ID:
        return <FromInputValue />;
      case TO_ID:
        return <DestinationInputValue />;
      case HOTEL_ID:
        return <HotelInputValue value={value} />;
      case WHEN_ID:
        return <DayPickerInputValue />;
      case NIGHTS_ID:
        return <NightsInputValue />;
      case TOURISTS_ID:
        return <TouristsInputValue />;

      default:
        return null;
    }
  };

  render() {
    const { id } = this.props;
    const value = this.selectInputValue(id);
    return <div>{value}</div>;
  }
}

InputValue.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
};

InputValue.defaultProps = {
  value: '',
};

export default InputValue;
